import defaultApi from '@/utils/request';

export default {
  // 加載列表
  S1XW2001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S1X/S1XW2001_Load',
      params,
    });
  },
  S1XW2001_getExamDetial(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S1X/S1XW2001_getExamDetial',
      params,
    });
  },
  S1XW2001_delExamAns(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S1X/S1XW2001_delExamAns',
      params,
    });
  },
  S1XW2001_SaveApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S1X/S1XW2001_SaveApply',
      data,
    });
  },
};
